import { Component, output, inject, input, ChangeDetectionStrategy } from '@angular/core';

import { Analytics } from '@core/analytics-types';
import { TranslatePipe } from '@core/i18n-legacy';
import { IntegrationItemComponent } from '@core/integrations-smart-ui';
import { DropdownItemComponent, IconComponent } from '@core/user-interface-legacy';

@Component({
  selector: 'rt-slack-integration',
  templateUrl: './slack-integration.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [IntegrationItemComponent, IconComponent, TranslatePipe, DropdownItemComponent],
})
export class SlackIntegrationComponent {
  public readonly analytics = inject(Analytics);

  public readonly hasSlackIntegrations = input<boolean>(undefined!);
  public readonly isSlackIntegrationLoaded = input<boolean>(undefined!);
  public edit = output<void>();
  public integrate = output<void>();
  public disconnect = output<void>();
}
